import './css/base-tabs-menu.scss';
import {
  HOSTED,
  CUSTOM
} from '../utils/Constants';

export const BaseTabsMenu = function ({ name, label, value, options = [], onSelect }) {
  return (
    <div className="base-tabs-menu" cy={name}>
      <b className="block m-b-8">{label}</b>
      <div className="flex">
        {options.map((option) => (
          <button
            key={option}
            className={`${value === option ? 'tab-selected' : ''}  ${option=== HOSTED ?'left-border':option=== CUSTOM ?'right-border':'no-border'} w100 bg-white pointer`}
            onClick={() => onSelect({ key: name, value: option })}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};
